import { injectable, inject } from 'inversify'

import { CartService } from '../services'
import { useCartStore } from '../store'

@injectable()
export class CartSupport {
  protected store: ReturnType<typeof useCartStore>

  constructor(
    @inject(CartService)
    readonly service: CartService,
  ) {
    this.store = useCartStore()
  }

  async loadCart(force = false) {
    if (this.store.cart && !force) return this.store.cart

    this.store.setCart(await this.service.getCart())

    return this.store.cart
  }

  checkInCart(productId: number) {
    return Boolean(
      this.store.cart?.items?.some(item => item.id === productId),
    )
  }

  async toggleNotify(productId: number) {
    const item = this.store.cart?.items?.find(i => i.id === productId)
    if (!item) return

    if (item.notifyInStock) {
      await this.service.unnotifyProduct(productId)
    } else {
      await this.service.notifyProduct(productId)
    }

    await this.loadCart(true)
  }
}
